import Tracker from './Tracker';
import TrackerQS from './TrackerQS';

export default Tracker;

export {
    Tracker, 
    TrackerQS
}